import { render } from "./TableGridMobile.vue?vue&type=template&id=c79f675a&scoped=true"
import script from "./TableGridMobile.vue?vue&type=script&lang=js"
export * from "./TableGridMobile.vue?vue&type=script&lang=js"

import "./TableGridMobile.vue?vue&type=style&index=0&id=c79f675a&scoped=true&lang=css"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-01d4bca84f43bee68-1/assemble-sports/aucklandrugbyleague-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79f675a"]])

export default __exports__